import styles from './Button.module.css';

export default function Button({ children, to, href, onClick, type = 'button', variant = 'primary' }) {
  const className = `${styles.button} ${styles[variant]}`;

  if (to) {
    return (
      <a href={to} className={className} onClick={onClick}>
        {children}
      </a>
    );
  }

  if (href) {
    return (
      <a href={href} className={className} target="_blank" rel="noopener noreferrer" onClick={onClick}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} className={className} onClick={onClick}>
      {children}
    </button>
  );
}
